import { render, staticRenderFns } from "./NutrientRichFoods.vue?vue&type=template&id=0abb1ae3&"
import script from "./NutrientRichFoods.vue?vue&type=script&lang=js&"
export * from "./NutrientRichFoods.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports